import React from 'react';

class Filter extends React.Component{
    state = {
        filter: {
            gender: 'any',
            language: ['any']
        }
    }
    render() {
        let { filter } = this.state;
        filter = {
            ...filter,
            ...this.props.filter
        };
        return (
            <React.Fragment>
                <div className="card-body search-filter-fields">
                    <div className="scroll-window">
                        <div className="scroll-window__card">
                            <div className="search-filter-fields__item" onClick={() => {
                                this.props.onFilterClick(this.props.step.GENDER);
                            }}>
                                <div className="search-filter-title">Gender</div>
                                <div className="search-filter-subtitle">{ filter.gender }</div>
                            </div>
                            <div className="search-filter-fields__item" onClick={() => {
                                this.props.onFilterClick(this.props.step.LANGUAGE);
                            }}>
                                <div className="search-filter-title">Language Spoken</div>
                                <div className="search-filter-subtitle">{ filter.language.map((l) => l).join(', ')}</div>
                            </div>
                        </div>
                    </div>    
                </div>
                <div className="card-footer" style={{ marginBottom: `${+this.props.headerHeight}px`}}>
                    <div onClick={() => {
                        if (this.props.onFilterApply) {
                            this.props.onFilterApply();
                        }
                    }} className="btn btn-green btn-footer"
                    >
                        Apply
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default Filter;